import {Component, Input, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {Router} from '@angular/router';
import { ApiAmenaService } from 'src/app/amena/services/api-amena.service';
import { DraftService } from 'src/app/amena/services/draft.service';
import { MobilePackService } from 'src/app/amena/services/mobile-pack.service';
import { ShoppingCartService } from 'src/app/amena/services/shopping-cart-service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-resumen',
    templateUrl: './resumen.component.html',
    styleUrls: ['./resumen.component.css', '../../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class ResumenComponent implements OnInit {
    @Input('ariaExpanded') ariaExpandedChild: boolean;
    @Input('showCollapse') showCollapseChild: boolean;
    router: string;
    itemTittle: string;
    public firstItem: number;
    public dataCustomer: any;
    public cartAgreements: any = {
        cp_price: 0,
        terminals: [],
        vap_price: 0,
        show: false
    };

    constructor(
        private shoppingCartService: ShoppingCartService,
        private _router: Router,
        public matDialog: MatDialog,
        private mobilePackService: MobilePackService,
        private draftService: DraftService,
        private amenaApi: ApiAmenaService
    ) {
        this.router = _router.url;

        if (this.router === '/amena/solo_movil') {
            this.itemTittle = 'Móvil principal';
            this.firstItem = 0;
        } else {
            this.itemTittle = 'Fijo y móvil';
            this.firstItem = 1;
        }
    }

    ngOnInit(): void {
        this.amenaApi.getDataFromCustomer()
            .subscribe((data: any) => {
                if (data) {
                    this.dataCustomer = data;
                }
            });
    }

    getShoppingCart() {
        this.productHasAgreement();
        return this.shoppingCartService.getShoppingCart();
    }

    getTerminalDeliveryTitle(terminalDelivery): string {
        if (terminalDelivery.type === 1) {
            return 'Entrega en Correos';
        } else if (terminalDelivery.type === 2) {
            return 'Mensajería';
        } else if (terminalDelivery.type === 3) {
            return 'Coste del envío';
        }

        return '';
    }    

    goToStep(index) {
        this.shoppingCartService.getStepper().selectedIndex = index;
    }

    removeExtraLine(index) {
        this.matDialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Eliminar linea móvil adicional',
                message: '¿Está seguro de querer eliminar la linea móvil adicional?'
            },
            panelClass: 'amena'
        })
            .afterClosed()
            .subscribe((confirm: boolean) => {
                if (confirm) {
                    this.draftService.removeMobile(index);
                    this.mobilePackService.setIndexToRemove(index);
                    this.shoppingCartService.getShoppingCart().removeItemsByStep(index);
                    this.shoppingCartService.setMonthlyTotal(this.shoppingCartService.getShoppingCart().getMonthlyTotal());
                    this.shoppingCartService.setInitialTotal(this.shoppingCartService.getShoppingCart().getInitialTotal());
                }
            });
    }

    productHasAgreement() {
        const itemsCart = this.shoppingCartService.getShoppingCart().getItems();
        this.cartAgreements = {
            cp_price: 0,
            terminals: [],
            vap_price: 0,
            show: false
        };
        if (this.dataCustomer && this.dataCustomer.products && itemsCart && itemsCart.length) {
            var found = this.dataCustomer.products
                .filter(product => itemsCart
                .some(item => (item.portability === product.msisdn || item.portability_fijo === product.msisdn)))
            if (found && found.length) {
                found.map(product => {
                    if (product.type !== 'broadband' && product.agreements && product.agreements.length) {
                        product.agreements.map(agreement => {
                            if (agreement.type === 'CP' && agreement.price > 0) {
                                this.cartAgreements.cp_price += agreement.price;
                                this.cartAgreements.show = true;
                            }
                        })
                    }

                    if (product.terminal && product.terminal !== '' && product.terminal.agreement && product.terminal.agreement.type === 'VAP') {
                        this.cartAgreements.terminals.push(product.terminal);
                        this.cartAgreements.vap_price += product.terminal.pending_payment;
                        this.cartAgreements.show = true;
                    }
                })
            }
        }
    }
}
